module.exports = __webpack_public_path__ + "img/user_LiShujuan.9a3d6809.png";